import LegalLayout from './LegalLayout';
import { OPERATOR } from './meta';

export default function Guidelines() {
  return (
    <LegalLayout title="コミュニティガイドライン" enacted={OPERATOR.effectiveDate}>
      <p>
        {OPERATOR.serviceName}
        は、VRMA（VRM Animation）を安心して共有できる場をめざしています。すべての利用者が気持ちよく利用できるよう、投稿にあたっては次のガイドラインを守ってください。本ガイドラインは利用規約の一部を構成します。
      </p>

      <h2>1. 権利を尊重する</h2>
      <ul>
        <li>自分に投稿・公開する権利があるコンテンツだけを投稿してください。</li>
        <li>
          他者が制作したモーション・アバター・キャラクターを、権利者の許諾なく流用・改変して投稿しないでください。
        </li>
        <li>
          VRM/VRMA
          モデルやモーションに設定された利用条件（ライセンス）を確認し、その範囲内で投稿・利用してください。とくに、特定のキャラクターやアバターの人格・肖像を想起させる利用は、権利者の許諾やライセンスの範囲に注意してください。
        </li>
      </ul>

      <h2>2. 投稿してはいけないもの</h2>
      <ul>
        <li>法令や公序良俗に反するコンテンツ。</li>
        <li>他者の著作権・商標権・肖像権・パブリシティ権・プライバシー・名誉を侵害するコンテンツ。</li>
        <li>わいせつ・過度に暴力的なコンテンツ、児童を性的に描写するコンテンツ。</li>
        <li>差別・誹謗中傷・ハラスメント・いじめを助長するコンテンツ。</li>
        <li>他者になりすます、または誤認させる内容。</li>
        <li>ウイルス等の有害なプログラムを含むファイル。</li>
        <li>スパム、無関係な宣伝・勧誘、詐欺的な内容。</li>
      </ul>

      <h2>3. 公開範囲の設定</h2>
      <p>
        投稿時に「公開」または「非公開」を選べます。公開すると、コンテンツとアカウント名が誰でも閲覧できる状態になります。第三者の権利や自身のプライバシーに配慮し、公開範囲を適切に設定してください。
      </p>

      <h2>4. 表示名・アカウント名</h2>
      <p>
        他者や実在の団体になりすます名称、権利を侵害する名称、公序良俗に反する名称は使用しないでください。
      </p>

      <h2>5. 違反への対応</h2>
      <p>
        本ガイドラインまたは利用規約に違反すると判断されたコンテンツは、事前の通知なく非表示・削除される場合があります。悪質な場合や繰り返される場合は、アカウントの利用停止・登録抹消の対象となります。
      </p>

      <h2>6. 権利侵害を見つけたら</h2>
      <p>
        自身の権利が侵害されていると考える場合、または不適切なコンテンツを見つけた場合は、「権利侵害の申告」ページの手順に従ってご連絡ください。運営者は内容を確認し、必要な対応を行います。
      </p>

      <p className="legal__meta">制定日: {OPERATOR.effectiveDate}</p>
    </LegalLayout>
  );
}
